import api from "./api";

export const ratesService = {
  getAll: async (
    page = 1,
    limit = 10,
    search = "",
    sortBy = "createdAt",
    sortOrder = "desc",
  ) => {
    const response = await api.get("/api/admin/rates", {
      params: { page, limit, search, sortBy, sortOrder },
    });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/api/admin/rates/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post("/api/admin/rates", data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.patch(`/api/admin/rates/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/api/admin/rates/${id}`);
    return response.data;
  },
};
